import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

// 淡入动画
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// 缩放动画
const zoomIn = keyframes`
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

// 弹窗遮罩层
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease;
`;

// 弹窗容器
const ModalContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  padding: 20px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: ${zoomIn} 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

// 弹窗头部
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 10px;
`;

// 弹窗标题
const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
`;

// 关闭按钮
const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
    color: #333;
  }
`;

// 弹窗内容
const ModalContent = styled.div`
  overflow-y: auto;
  font-size: 14px;
  flex: 1;
  padding-right: 5px;
  
  /* 自定义滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
  
  p {
    margin-bottom: 12px;
    line-height: 1.5;
  }
  
  strong {
    color: #FF6B6B;
  }
`;

interface GameRulesModalProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
}

const GameRulesModal: React.FC<GameRulesModalProps> = ({ className, isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <>  
      {isOpen && (
        <ModalOverlay onClick={onClose}>
          <ModalContainer onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{t('rules.title')}</ModalTitle>
              <CloseButton onClick={onClose}>×</CloseButton>
            </ModalHeader>
            <ModalContent>
              <p><strong>{t('rules.howToPlay')}:</strong></p>
              <p>1. {t('rules.rule1')}</p>
              <p>2. {t('rules.rule2')}</p>
              <p>3. {t('rules.rule3')}</p>
              <p>4. {t('rules.rule4')}</p>
              <p>5. {t('rules.rule5')}</p>
              <p>6. {t('rules.rule6')}</p>
              <p><strong>{t('rules.gameModes')}:</strong></p>
              <p>1. {t('rules.endlessMode')}</p>
              <p>2. {t('rules.levelMode')}</p>
              <p><strong>{t('rules.itemSystem')}:</strong></p>
              <p>1. {t('rules.resetItem')}</p>
              <p>2. {t('rules.swapItem')}</p>
              <p>3. {t('rules.upgradeItem')}</p>
              <p>4. {t('rules.recoverItem')}</p>
              <p>5. {t('rules.reviveItem')}</p>
            </ModalContent>
          </ModalContainer>
        </ModalOverlay>
      )}
    </>
  );
};

export default GameRulesModal; 